import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { debug } from 'console';
import { WebcamImage, WebcamInitError } from 'ngx-webcam';
import { AfterViewInit, ElementRef, NgZone, OnDestroy } from '@angular/core';

declare let $: any;
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'webcam-modal',
  templateUrl: './webcam-modal.component.html',
  styleUrls: ['./webcam-modal.component.scss']
})
export class WebcamModalComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor(private hostElement: ElementRef, private ngZone: NgZone) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    const modal = $(this.hostElement.nativeElement).find('.modal');

    modal.one('shown.bs.modal.webcamModal', () => {
      this.ngZone.run(() => this.cameraActive = true);
    });
    modal.one('hidden.bs.modal.webcamModal', () => {
      this.ngZone.run(() => {
        this.cameraActive = false;
        this.onModalClosed.emit();
      });
    });
    modal.modal('show');
  }

  ngOnDestroy(): void {
    const modal = $(this.hostElement.nativeElement).find('.modal');
    modal.off('.webcamModal');
  }

  @Output() onImageCaptured = new EventEmitter<string>(); // Custom event
  @Output() onModalClosed = new EventEmitter<void>();

  public allowCameraSwitch = true;
  public deviceId: string;
  public videoOptions: MediaTrackConstraints = {
    // width: {ideal: 1024},
    // height: {ideal: 576}
  };

  public errors: WebcamInitError[] = [];
  public cameraActive = false;

  capturedImage: string | null = null;
  approvedCapturedImage: string | null = null;

  private trigger: Subject<void> = new Subject<void>();

  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors = [error];
  }

  public cameraWasSwitched(deviceId: string): void {
    this.deviceId = deviceId;
  }

  public handleImage(webcamImage: WebcamImage): void {
    this.capturedImage = webcamImage.imageAsDataUrl;
  }

  public onOkClicked() {
    this.approvedCapturedImage = this.capturedImage;
    this.onImageCaptured.emit(this.approvedCapturedImage);
  }

  public onCancelClicked() {
    this.capturedImage = this.approvedCapturedImage;
  }

  public triggerSnapshot(): void {
    this.trigger.next();
  }
}
